import ReactDOM from 'react-dom'


export default function outside(elem){
    return ReactDOM.createPortal(
        elem,
        document.getElementById("app-outside")
    )
}